export default {"src":"/pro/_next/static/media/gmmeme.9f2bb6f0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};